import React, { Fragment, useState, useEffect } from 'react'
import { useLocation, withRouter } from 'react-router-dom'
// Import the main component
import { Viewer } from '@react-pdf-viewer/core'; // install this library
// Plugins
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout'; // install this library
// Import the styles
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
// Worker
import { Worker } from '@react-pdf-viewer/core'; // install this library


function VisualizadorPDF(props) {

    const urlPDF = useLocation();

    const defaultLayoutPluginInstance = defaultLayoutPlugin();

    useEffect(() => {
        console.log(urlPDF.state)
    }, [urlPDF])

    return (
        <Fragment>
            <div className='container'>
                {props.urlPDF && <><Worker workerUrl="https://unpkg.com/pdfjs-dist@2.14.305/build/pdf.worker.min.js">
                    <Viewer
                        fileUrl={props.urlPDF}
                        plugins={[defaultLayoutPluginInstance]}
                        initialPage={2}

                    />
                </Worker></>}
                {/* if we dont have pdf or viewPdf state is null */}
                {!props.urlPDF && <>No pdf file selected</>}
            </div>

        </Fragment>
    )
}

export default withRouter(VisualizadorPDF)
